exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs li.router-link-exact-active a[data-v-5ec5eba6]{border-bottom-color:#07689f;color:#07689f}.mainContent[data-v-5ec5eba6]{padding:0 60px}.topSubMenu[data-v-5ec5eba6]{padding:0 60px;margin:10px 0 5px}.selectedMenu li a[data-v-5ec5eba6]{color:#510087;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ec5eba6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/graficas/GraphicsMenu.vue
// module id = 947
// module chunks = 2